import React from 'react';
import { formatNumber } from '../../../common/lib/formatNumber';
import type { MotorAd, SearchKey } from '../../../types';

const SHOW_MILEAGE_FOR_SEARCH_KEYS = [
    'SEARCH_ID_CAR_USED',
    'SEARCH_ID_CAR_PARALLEL_IMPORT',
    'SEARCH_ID_CAR_TRUCK',
    'SEARCH_ID_CAR_TRUCK_ABROAD',
    'SEARCH_ID_MC_USED',
    'SEARCH_ID_MC_SNOWMOBILE',
    'SEARCH_ID_MC_SCOOTER',
    'SEARCH_ID_MC_ATV',
    'SEARCH_ID_CAR_MOBILE_HOME',
];

type MotorSummaryProps = {
    ad: MotorAd;
    className?: string;
    searchKey: SearchKey;
};

export function MotorSummary(props: MotorSummaryProps) {
    const { ad, className = '', searchKey } = props;

    const isSold = ad.flags.includes('sold');

    const showMileage =
        ad.mileage &&
        ad.mileage > 0 &&
        SHOW_MILEAGE_FOR_SEARCH_KEYS.includes(searchKey);
    const showPrice = ad.price.amount > 0 && !isSold;
    const showYear = ad.year > 0;

    const getMileageText = (mileage: number) => `${formatNumber(mileage)} km`;
    const getPriceText = (amount: number) =>
        `${formatNumber(amount)} ${ad.price.price_unit}`;

    return (
        <div className={`${className} space-x-12 font-bold whitespace-nowrap`}>
            {ad.year && showYear && <span>{ad.year}</span>}
            {ad.mileage && showMileage && (
                <span>{getMileageText(ad.mileage)}</span>
            )}
            {showPrice && <span>{getPriceText(ad.price.amount)}</span>}
            {isSold && <span>Solgt</span>}
        </div>
    );
}
